import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Tooth = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M22 28C19.794 28 18 26.206 18 24V22C18 20.897 17.103 20 16 20C14.897 20 14 20.897 14 22V24C14 26.206 12.206 28 10 28C7.794 28 6 26.206 6 24V21.75C6 18.57 5.367 16.623 4.809 14.906C4.393 13.626 4 12.416 4 11C4 9.279 4.551 7.557 5.513 6.275C6.613 4.808 8.163 4 9.875 4C11.787 4 13.054 4.709 14.072 5.278C14.793 5.681 15.362 6 16 6C16.653 6 17.25 5.673 18.006 5.258C19.029 4.697 20.301 4 22.125 4C23.787 4 25.318 4.805 26.435 6.268C27.429 7.57 28 9.294 28 11C28 12.417 27.607 13.626 27.191 14.906C26.633 16.623 26 18.57 26 21.75V24C26 26.206 24.206 28 22 28ZM16 18C18.206 18 20 19.794 20 22V24C20 25.103 20.897 26 22 26C23.103 26 24 25.103 24 24V21.75C24 18.253 24.715 16.055 25.289 14.288C25.686 13.065 26 12.1 26 11C26 8.585 24.443 6 22.125 6C20.814 6 19.917 6.492 18.967 7.012C18.081 7.498 17.165 8 16 8C14.84 8 13.953 7.504 13.095 7.024C12.154 6.498 11.265 6 9.875 6C7.97 6 6 7.87 6 11C6 12.1 6.314 13.065 6.711 14.288C7.285 16.055 8 18.253 8 21.75V24C8 25.103 8.897 26 10 26C11.103 26 12 25.103 12 24V22C12 19.794 13.794 18 16 18V18Z" />
	</svg>
);

export default Tooth;
